module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f3141e783e3d0ee5bbdb3ec7d1fba24c.gif";